import { useIntl } from 'react-intl';
import Modal from '@/shared/components/Modal';
import ConfigurationForm from './ConfigurationModal/ConfigurationForm';
import { type SchedulePreferencesPayload } from '@/features/accounts/api';
import { Schedule } from '@/features/accounts/types';

interface Props {
  schedule: Schedule | null;
  countryCode: string;
  preferences?: SchedulePreferencesPayload;
  onClose: () => void;
  onSubmit: (preferences: SchedulePreferencesPayload) => Promise<void>;
}

export default function ConfigurationModal({ schedule, countryCode, preferences, onClose, onSubmit }: Props) {
  const intl = useIntl();

  if (!schedule) return null;

  return (
    <Modal
      isOpen={!!schedule}
      onClose={onClose}
      title={intl.formatMessage({ id: 'accounts.config.title' })}
      eyebrow={intl.formatMessage(
        { id: 'accounts.config.scheduleTitle' },
        { id: schedule.external_id ?? schedule.id }
      )}
    >
      <ConfigurationForm
        schedule={schedule}
        countryCode={countryCode}
        preferences={preferences}
        onSubmit={onSubmit}
      />
    </Modal>
  );
}
